import React from 'react'

const t = {
  FR: {
    specifics_footerDeleteAccount: {'page title': 'Supprimer mon compte',},
    'text 1': <>Tout utilisateur peut supprimer définitivement son compte Incohérences.</>,
    'text 2': <>Pour ce faire, une connexion réussie doit être faite à l'aides des 3 icônes OU du mot de passe.</>,
    'text 3': <>Il faut ensuite accéder à votre profil et cliquer sur l'option <code>Supprimer mon compte</code>.<br />
      <span className='smallItalic'>&nbsp;&nbsp;&nbsp;(Cette fonction est à venir)</span></>,
    'text 4': <>La deuxième méthode d'authentification sera demandée. Il est donc important de conserver les deux méthode de manière sécuritaire.</>,
  },
  EN: {
    specifics_footerDeleteAccount: {'page title': 'Delete my account',},
    'text 1': <>Any user can permanently delete their Incohérences account.</>,
    'text 2': <>To do this, a successful connection must be made using the 3 icons OR the password.</>,
    'text 3': <>You must then access your profile and click on the <code>Delete my account</code> option.<br />
      <span className='smallItalic'>&nbsp;&nbsp;&nbsp;(This feature is coming soon)</span></>,
    'text 4': <>The second authentication method will be requested. It is therefore important to keep both methods secure.</>,
  },
  ES: {
    specifics_footerDeleteAccount: {'page title': 'Eliminar mi cuenta',},
    'text 1': <>Cualquier usuario puede eliminar permanentemente su cuenta de Incohérences.</>,
    'text 2': <>Para hacer esto, se debe realizar una conexión exitosa usando los 3 íconos O la contraseña.</>,
    'text 3': <>Luego deberás acceder a tu perfil y hacer clic en la opción <code>Eliminar mi cuenta</code>.<br />
      <span className='smallItalic'>&nbsp;&nbsp;&nbsp;(Esta función estará disponible próximamente)</span></>,
    'text 4': <>Se solicitará el segundo método de autenticación. Por tanto, es importante mantener ambos métodos seguros.</>,
  },
  PT: {
    specifics_footerDeleteAccount: {'page title': 'Deletar minha',},
    'text 1': <>Qualquer usuário pode excluir permanentemente sua conta do Incohérences.</>,
    'text 2': <>Para isso, uma conexão bem-sucedida deve ser feita usando os 3 ícones OU a senha.</>,
    'text 3': <>Em seguida, você deve acessar seu perfil e clicar na opção <code>Delete my account</code>.<br />
      <span className='smallItalic'>&nbsp;&nbsp;&nbsp;(Essa funcionalidade estará disponível em breve)</span></>,
    'text 4': <>O segundo método de autenticação será solicitado. Portanto, é importante manter ambos os métodos seguros.</>,
  },
}

export default t